import * as React from "react";
import { styled } from "@mui/material";
import { ReactComponent as KahunLogo } from "../assets/kahunLogoNew.svg";
import { ReactComponent as LadingPageDotsBackground } from "../assets/landingPageDotsBackground.svg";
import clsx from "clsx";

//region [[ Styles ]]

const PageLayoutView = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  alignContent: "center",
  flexWrap: "wrap",
  background: "linear-gradient(180deg, #F7F6FF 0%, #FFF1E9 100%)",
  minHeight: "100%",
  //borderBottom: "9px solid #857FDC",
  zIndex: 1,
});

const DotsBackground = styled(LadingPageDotsBackground)({
  position: "fixed",
  zIndex: 2,
  right: "5%",
  bottom: "10%",
  opacity: 0.4,
});

const TopArea = styled("div")(({ theme }) => ({
  zIndex: 3,
  flex: 0,
  display: "flex",
  flexFlow: "row",
  justifyContent: "flex-start",
  width: "92%",
  padding: "36px 0",
  "& svg": {
    cursor: "pointer",
  },
  [theme.breakpoints.down("xs")]: {
    // Make it render in center for mobile, since parent flex box justifies to center
    width: "fit-content",
    padding: "26px 10px 16px 10px",
  },
}));

const ContentView = styled("div")(({ theme }) => ({
  zIndex: 3,
  flex: 1,
  width: "100%",
  display: "flex",
  flexFlow: "column",
  [theme.breakpoints.down("xs")]: {
    padding: "0 15px",
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface LandingPageLayoutProps {
  className?: string;
  children?: React.ReactNode;
  onHome?: () => void;
  topArea?: React.ReactNode;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const LandingPageLayout = ({ ...props }: LandingPageLayoutProps) => {
  return (
    <PageLayoutView className={clsx("landing-page-layout", props.className)}>
      <DotsBackground className={"dot-background"} />
      <TopArea className={"top-bar"}>
        {props.topArea ? (
          props.topArea
        ) : (
          <KahunLogo onClick={() => props.onHome?.()} />
        )}
      </TopArea>
      <ContentView className={"content-view"}>{props.children}</ContentView>
    </PageLayoutView>
  );
};
